import styled from "styled-components";

const Divider = ({ isMobile }) => <StyledDivider isMobile={isMobile} />;

const StyledDivider = styled.hr`
  color: rgba(0, 0, 0, 1);
  width: 100%;

  ${({ isMobile }) => isMobile && `
    @media (min-width: 841px) {
      display: none;
    }
  `}
`;

export default Divider;
